import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { NavbarSuperAdminComponent } from "./navbar-superadmin.component";
import { SharedModule } from "app/shared/shared.module";

@NgModule({
  imports: [RouterModule, CommonModule, SharedModule],
  declarations: [NavbarSuperAdminComponent],
  exports: [NavbarSuperAdminComponent],
})
export class NavbarSuperAdminModule {}
